import { AbstractControl } from "@angular/forms";
import * as moment from 'moment';

export function requiredValidator(control: AbstractControl): { [key: string]: any } | null {
	const requiredField = control.value.toString().trim();
	if (requiredField.length === 0) {
		return { "required": true }
	}
	else {
		return null;
	}
}

export function requiredBusinessType(control: AbstractControl): { [key: string]: any } | null {
	const businessType = control.value.toString().trim();
	if (businessType === 'NA' || businessType.length === 0) {
		return { "businessTyperequired": true }
	}
	else {
		return null;
	}
}

export function dateValidator(control: AbstractControl): { [key: string]: any } | null {
	const dateData = control.value ?? ""
	if (dateData.trim().length === 0) {
		return { "dateRequired": true }
	} else
		if (!new RegExp("^([0-9]{2})/([0-9]{2})/([0-9]{4})$").test(dateData.trim()) || validateDate(dateData)) {
			return { "dateFormatErr": true }
		}
		// if valid date check for condition - Business Start year < current year 
		// else if (validateDate(dateData) === false) {
		//     if (dateData.split("/")[2] < moment().year()) {
		//         return { "priorYearErr": true }
		//     } else {
		//         return null;
		//     }
		// }
		else {
			return null;
		}
}
export function validateDate(dateData: string): boolean {
	if (moment(dateData, "MM/DD/YYYY", true).isValid() === false) {
		return true;
	}
	else {
		return false;
	}

}
export function requiredPayReceipt(control: AbstractControl): { [key: string]: any } | null {
	const payReceipt = control.value ?? ""
	if (payReceipt === "" || payReceipt.length === 0 || payReceipt === null || payReceipt === "NA") {
		return { "payDirectrequired": true }
	}else if(payReceipt.length>0){
		const isValid = ((payReceipt.length > 0) && (payReceipt.search(new RegExp("\\D")) === -1)) ? true : false;
			if(isValid===true){
				return null;
			}else {
				return { "payDirectrequiredErr": !isValid }
			}
	}
	else {
		return null;
	}
}


export function validateTextField(event: any): boolean {
	const inputElObj = event.value;
	const isValid = ((inputElObj.length > 0) && (inputElObj.search(new RegExp("\\D")) === -1)) ? true : false;
	return isValid;
}
export function validateNAICS(control: AbstractControl): { [key: string]: any } | null {
	const naics = control.value.toString().trim();
	if (naics === 'NA' || naics.length === 0 ) {
		return null;
	}
	else if(naics.length===6) {
			const isValid = ((naics.length > 0) && (naics.search(new RegExp("\\D")) === -1)) ? true : false;
			if(isValid===true){
				return null;
			}else {
				return { "naicsValidationErr": true }
			}
			
	}else{
			return { "naicsValidationErr": true }
	}
}

export function validateSICS(control: AbstractControl): { [key: string]: any } | null {
	const sics = control.value.toString().trim();
	if (sics === 'NA' || sics.length === 0 ) {
		return null;
	}
	else if(sics.length===4) {
			const isValid = ((sics.length > 0) && (sics.search(new RegExp("\\D")) === -1)) ? true : false;
			if(isValid===true){
				return null;
			}else {
				return { "sicsValidationErr": true }
			}
			
	}else{
			return { "sicsValidationErr": true }
	}
}

export function validateField(control: AbstractControl): { [key: string]: any } | null {
	const ggr = control.value ?? ""
	if (ggr === "" || ggr.length === 0 || ggr === null || ggr === "NA") {
		return null;
	}else if(ggr.length>0){
		const isValid = ((ggr.length > 0) && (ggr.search(new RegExp("\\D")) === -1)) ? true : false;
			if(isValid===true){
				return null;
			}else {
				return { "measureErr": !isValid }
			}
	}
	else {
		return null;
	}
}
//INC0754669 - Enhancement - PFA EappReg - Adding GGR
export function validateGgr(control: AbstractControl): { [key: string]: any } | null {
	const ggr = control.value ?? ""
	const requiredField = control.value.toString().trim();
	if (ggr.length === 0) {
		return { "required": true }
	}
	else if(ggr.length>0){
		if (ggr < Number(sessionStorage.getItem("totalMsr"))) {
			return { "validateGgrErr": true }
		}else{
			return null;
		}
	}
	else {
		return null;
	}
}